module.exports = __webpack_public_path__ + "img/zhimazaoni.78534b74.jpg";